import * as apiFunction from '@services/apiFunctions'

import { API_URLS } from '@services/apiRoutes'
import { clearsEmptyProperties } from '@utils/functions/clearsEmptyProperties'

import type {
  EditItemPurchaseOrderObservationsRequestProps,
  GetItemsPurchaseOrdersRequestProps,
  GetPurchaseOrdersRequestProps,
  ReversePurchaseOrderRequestProps,
  TransferPurchaseOrderRequestProps
} from './types'

export const reversePurchaseOrder = async ({ routeParams, bodyParams }: ReversePurchaseOrderRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.consumption}/${routeParams.filiCode}/reverter-ordem-compra/dt-competencia/${routeParams.competenceDate}`,
    method: 'POST',
    body
  })
}

export const transferPurchaseOrder = async ({ routeParams, bodyParams }: TransferPurchaseOrderRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.consumption}/${routeParams.filiCode}/transferir-ordem-compra/dt-competencia/${routeParams.competenceDate}`,
    method: 'POST',
    body
  })
}

export const editItemPurchaseOrderObservation = async ({
  routeParams,
  bodyParams
}: EditItemPurchaseOrderObservationsRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.consumption}/${routeParams.filiCode}/observacao-ordem-compra/dt-competencia/${routeParams.competenceDate}`,
    method: 'PUT',
    body
  })
}

export const getItemsPurchaseOrders = async ({ routeParams, bodyParams }: GetItemsPurchaseOrdersRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.consumption}/${routeParams.filiCode}/busca-itens-ordem-compra/dt-competencia/${routeParams.competenceDate}/fornecedor/${routeParams.supplierCode}`,
    method: 'POST',
    body
  })
}

export const getPurchaseOrders = async ({ routeParams, bodyParams }: GetPurchaseOrdersRequestProps) => {
  const body = clearsEmptyProperties(bodyParams)
  return await apiFunction.apiRequestWithBody({
    url: `${API_URLS.finapi.consumption}/${routeParams.filiCode}/busca-ordem-compra/dt-competencia/${routeParams.competenceDate}/fornecedor/${routeParams.supplierCode}`,
    method: 'POST',
    body
  })
}
